export default {"src":"/_next/static/media/aig.b7500fde.svg","height":48,"width":79,"blurWidth":0,"blurHeight":0};